import type {ToDoSkillsQuery} from './queries/StudentSkillPath.queries.generated';

export type BadgeCounts = Record<1 | 2 | 3, number>;

export const DEFAULT_BADGE_COUNTS: BadgeCounts = {1: 0, 2: 0, 3: 0};

export const FILTER_OPTION = {
  ALL: 'All',
  TO_DO: 'To Do'
} as const;

export type FilterOption = (typeof FILTER_OPTION)[keyof typeof FILTER_OPTION];

export interface SkillGuide {
  guideId: string;
  guideName: string;
  items: SkillItem[];
}

export interface SkillItem {
  id: string;
  name: string;
  code: string | null;
  myProficiencyLevel: number | null;
  dueDate: string | null;
}

export interface DiagnosticItem {
  diagnosticId: string;
  name: string;
  subjectName: string;
  guideName: string;
  dueDate: string | null;
}

export interface SkillSubjectGroup {
  subjectId: string;
  subjectName: string;
  browseUrl: string;
  skillGuides: SkillGuide[];
}

export type ToDoSkills = NonNullable<NonNullable<ToDoSkillsQuery['subjects']>['results']>;
